import React, { useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Badge } from '@mui/material';
import { DivElement } from './styles';
import { TableControls } from '../../../../BaseEditor';
import { fieldsPropType } from './PropTypes';
import { AppContext } from '../../../../../providers/authProvider';
import api from '../../../../../api/req';

function BodyComponent({
  row, rowNumber, onChange, active, fields, onClick, index, typeView, id, docId,
}) {
  const { auth } = useContext(AppContext);
  const [err, setErr] = useState(null);
  const [showLog, setShowLog] = useState(false);
  const cr = index * 3 + 3;
  const globalProps = {
    onClick: (e) => onClick(e, rowNumber),
  };

  const globalStyle = active ? {
    background: active ? 'linear-gradient(0deg,rgba(255,255,255,0.7),rgba(255,255,255,0.7)),#008F21' : 'initial',
  } : {};

  const negativeSumStyle = ((row.order_amount < 0) || (row.revenue_amount < 0)) ? { background: '#fba7a7' }
    : {};

  function autoSave(param, event) {
    const loader = async () => {
      const r = await api.post$(
        '/api/subscriptions/saveRowSubscriptions/ ',
        auth,
        {
          ...row,
          ...param,
        },
      );
      if (r.ok) {
        const d = await r.json();
        if (d.info) onChange(event, rowNumber, { subscription_extension: d });
      } else {
        throw new Error(`${r.status} ${r.statusText}`);
      }
    };
    loader()
      .then(() => null)
      .catch((e) => setErr(e.message));
  }

  const rowInfo = useMemo(() => {
    if (!row.subscription_extension) return null;
    const keys = Object.keys(row.subscription_extension.info);
    return keys.map((el) => {
      const info = row.subscription_extension.info[el];
      if (info.filed) {
        // eslint-disable-next-line no-constant-condition
        const recInfo = `${el} Користувач: ${info.user} змінив "${fields[info.filed.replace('_id', '')].label}" з ${info.old_value} на ${info.new_value}`
          .replace('true', '"Так"')
          .replace('false', '"Ні"');
        return (
          <p>
            {recInfo}
          </p>
        );
      }
      return (<br />);
    });
  }, [fields, row.subscription_extension]);

  return (
    <>
      {err && (
        <Alert severity="error">
          {err}
        </Alert>
      )}

      <DivElement
        style={{
          ...globalStyle,
          gridArea: `${cr} / payer`,
          display: 'flex',
        }}
        {...globalProps}
      >
        <Badge
          badgeContent={row.index + 1}
          color="primary"
          max={9999}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',

          }}
          sx={{
            right: -1,
            top: 2,
          }}
        />
        <div style={{ marginLeft: '2px', width: '100%' }}>
          <TableControls.ItemPicker
            id={id}
            value={row.payer}
            backend="/api/catalog/payers/"
            onChange={(e, v) => {
              onChange(e, rowNumber, { payer: v, contract: { id: null, repr: '' } });
              autoSave({
                payer_id: v.id,
                payer: v,
              }, e);
            }}
            readOnly={fields.payer_id.read_only}
            columns={fields.payer.children}
            width="100%"
            canErase
          />
        </div>

      </DivElement>

      <DivElement
        style={{
          ...globalStyle,
          gridArea: `${cr + (typeView ? 1 : 0)} / contract`,
        }}
        {...globalProps}
      >
        <TableControls.ItemPicker
          value={row.contract}
          backend="/api/catalog/contracts/"
          onChange={(e, v) => {
            onChange(e, rowNumber, { contract: v });
            autoSave({
              contract: v,
              contract_id: v.id,
            }, e);
          }}
          readOnly={fields.contract_id.read_only}
          columns={fields.contract.children}
          filter={{ payer: row.payer ? row.payer.id : null }}
          canErase
        />
      </DivElement>
      <DivElement
        style={{
          ...globalStyle,
          textAlign: 'center',
          gridArea: `${cr} / warning`,
        }}
        {...globalProps}
      >
        <TableControls.CheckboxInput
          value={row.warning}
          onChange={(e, v) => {
            onChange(e, rowNumber, { warning: v });
            autoSave({
              warning: v,
            }, e);
          }}
          readOnly={fields.warning.read_only}
        />
      </DivElement>
      <DivElement
        style={{
          ...globalStyle,
          textAlign: 'right',
          gridArea: `${cr + (typeView ? 1 : 0)} / payment_number`,
        }}
        {...globalProps}
      >
        <TableControls.NumerInput
          value={Number(row.payment_number)}
          onChange={(e, v) => {
            onChange(e, rowNumber, { payment_number: v.toFixed(0) });
            autoSave({
              payment_number: v,
            }, e);
          }}
          readOnly={fields.payment_number.read_only}
          precision={0}
        />
      </DivElement>

      <DivElement
        style={{
          ...globalStyle,
          gridArea: `${cr + (typeView ? 0 : 1)} / payment_notes ${typeView ? '/ span 2' : ''}`,
          display: 'Flex',
          justifyContent: 'space-around',
          flexDirection: 'column',
        }}
        {...globalProps}
      >
        {row.subscription_extension && (
          <Badge
            badgeContent="I"
            color="secondary"
            onClick={() => setShowLog(!showLog)}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',

            }}
            sx={{
              right: -1,
              top: 2,
            }}
          />
        )}
        <div style={{ marginLeft: '5px' }}>
          <TableControls.TextInput
            value={row.payment_notes}
            onChange={(e, v) => {
              onChange(e, rowNumber, { payment_notes: v });
              // autoSave({
              //   payment_number: v,
              // }, e);
            }}
            readOnly={(docId !== 'create')}
          />

        </div>

        {row.subscription_extension && showLog && (
          <Alert severity="error" onClick={() => setShowLog(false)}>
            {rowInfo}
          </Alert>
        )}

      </DivElement>

      <DivElement
        style={{
          ...globalStyle,
          textAlign: 'right',
          gridArea: `${cr} / order_amount ${typeView ? '/ span 2' : ''}`,
          ...negativeSumStyle,
        }}
        {...globalProps}
      >
        <TableControls.NumerInput
          value={Number(row.order_amount)}
          onChange={(e, v) => {
            onChange(e, rowNumber, { order_amount: v.toFixed(2) });
            autoSave({
              order_amount: v,
            }, e);
          }}
          readOnly={fields.order_amount.read_only}
          precision={2}
        />

      </DivElement>

      <DivElement
        style={{
          ...globalStyle,
          textAlign: 'right',
          gridArea: `${cr} / revenue_amount  ${typeView ? '/ span 2' : ''}`,
          ...negativeSumStyle,
        }}
        {...globalProps}
      >
        <TableControls.NumerInput
          value={Number(row.revenue_amount)}
          onChange={(e, v) => {
            onChange(e, rowNumber, { revenue_amount: v.toFixed(2) });
            autoSave({
              revenue_amount: v,
            }, e);
          }}
          readOnly={fields.revenue_amount.read_only}
          precision={2}
        />
      </DivElement>
    </>

  );
}

BodyComponent.propTypes = {
  row: PropTypes.shape({
    index: PropTypes.number.isRequired,
    subscription_extension: PropTypes.shape({ info: {} }),
    payer: PropTypes.shape({
      id: PropTypes.number,
      full_name: PropTypes.string,
      payment_number: PropTypes.string,
      payment_notes: PropTypes.string,
      order_amount: PropTypes.number,
      revenue_amount: PropTypes.number,
      warning: PropTypes.bool,
    }),
    contract: PropTypes.shape({}),
    payment_number: PropTypes.string,
    payment_notes: PropTypes.string,
    order_amount: PropTypes.number,
    revenue_amount: PropTypes.number,
    warning: PropTypes.bool,
  }),
  fields: fieldsPropType,
  rowNumber: PropTypes.number,
  onChange: PropTypes.func,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  shift: PropTypes.number,
  index: PropTypes.number.isRequired,
  typeView: PropTypes.bool,
  id: PropTypes.string,
  docId: PropTypes.string,
};

BodyComponent.defaultProps = {
  row: {
    payer: {},
    contract: {},
    subscription_extension: null,
  },
  fields: {
    account: {},
    payer: {},
    contract: {},
  },
  rowNumber: 0,
  onChange: () => null,
  active: false,
  onClick: () => null,
  shift: 0,
  typeView: false,
  id: null,
  docId: 'create',
};

export default BodyComponent;
